// ── Shared God Mode theme tokens ──────────────────────────────────────────────
// Light/gold theme — import this in every God Mode page
export const G = {
  // Colors
  gold:        '#B7791F',
  goldLight:   '#FEF3C7',
  goldBorder:  '#F6AD55',
  goldDeep:    '#92400E',

  // Neutrals (light theme)
  text:        '#1F2937',
  textSub:     '#374151',
  textMuted:   '#6B7280',
  textFaint:   '#9CA3AF',
  border:      '#E5E7EB',
  borderStrong:'#D1D5DB',
  bg:          '#F9FAFB',
  bgAlt:       '#F3F4F6',
  surface:     '#FFFFFF',

  // Status colors (same across themes)
  active:    '#16A34A',
  activeBg:  '#DCFCE7',
  trial:     '#D97706',
  trialBg:   '#FEF3C7',
  suspended: '#DC2626',
  suspendedBg:'#FEE2E2',
  churned:   '#6B7280',
  churnedBg: '#F3F4F6',

  // Typography
  fontBrand: "'Sora', sans-serif",
};

// ── Shared style objects ───────────────────────────────────────────────────────
export const GS = {
  page:      { maxWidth: '960px' },
  title:     { fontSize: '22px', fontWeight: 800, color: '#1F2937', marginBottom: '4px', letterSpacing: '-0.04em', fontFamily: "'Sora', sans-serif" },
  sub:       { fontSize: '13px', color: '#6B7280' },
  card:      { background: '#FFFFFF', border: '1px solid #E5E7EB', borderRadius: '14px', padding: '20px 22px', boxShadow: '0 1px 4px rgba(0,0,0,0.04)' },
  cardTitle: { fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: '#6B7280', marginBottom: '14px' },
  input:     { width: '100%', padding: '10px 14px', borderRadius: '10px', border: '1.5px solid #E5E7EB', background: '#F9FAFB', color: '#1F2937', fontSize: '14px', outline: 'none' },
  btnPrimary:{ padding: '10px 20px', borderRadius: '10px', background: 'linear-gradient(135deg, #B7791F 0%, #D97706 100%)', color: '#fff', border: 'none', cursor: 'pointer', fontSize: '14px', fontWeight: 700, boxShadow: '0 2px 8px rgba(183,121,31,0.3)' },
  btnSecondary:{ padding: '10px 20px', borderRadius: '10px', background: '#F9FAFB', color: '#374151', border: '1px solid #E5E7EB', cursor: 'pointer', fontSize: '14px', fontWeight: 500 },
  btnDanger: { padding: '10px 20px', borderRadius: '10px', background: '#FEE2E2', color: '#DC2626', border: '1px solid #FECACA', cursor: 'pointer', fontSize: '14px', fontWeight: 700 },
  errBox:    { padding: '12px 16px', background: '#FEF2F2', border: '1px solid #FECACA', borderRadius: '10px', color: '#DC2626', fontSize: '13px', marginBottom: '14px' },
  sucBox:    { padding: '12px 16px', background: '#F0FDF4', border: '1px solid #BBF7D0', borderRadius: '10px', color: '#15803D', fontSize: '13px', marginBottom: '14px' },
  overlay:   { position: 'fixed', inset: 0, background: 'rgba(17,24,39,0.5)', display: 'flex', alignItems: 'flex-end', justifyContent: 'center', zIndex: 200, padding: '16px' },
  modal:     { background: '#FFFFFF', borderRadius: '20px 20px 16px 16px', padding: '28px 24px', width: '100%', maxWidth: '560px', maxHeight: '92vh', overflowY: 'auto', boxShadow: '0 -4px 40px rgba(0,0,0,0.12)' },
  modalHdr:  { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' },
  modalTitle:{ fontSize: '18px', fontWeight: 700, color: '#1F2937', letterSpacing: '-0.03em', fontFamily: "'Sora', sans-serif" },
  modalClose:{ background: '#F3F4F6', border: 'none', width: '30px', height: '30px', borderRadius: '50%', fontSize: '18px', cursor: 'pointer', color: '#6B7280', display: 'flex', alignItems: 'center', justifyContent: 'center' },
};

export const STATUS_META = {
  TRIAL:     { color: '#D97706', bg: '#FEF3C7', border: '#FDE68A', label: 'Trial'     },
  ACTIVE:    { color: '#16A34A', bg: '#DCFCE7', border: '#BBF7D0', label: 'Active'    },
  SUSPENDED: { color: '#DC2626', bg: '#FEE2E2', border: '#FECACA', label: 'Suspended' },
  CHURNED:   { color: '#6B7280', bg: '#F3F4F6', border: '#E5E7EB', label: 'Churned'   },
};

export function StatusPill({ status }) {
  const m = STATUS_META[status] || STATUS_META.TRIAL;
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: '5px',
      fontSize: '11px', fontWeight: 700, padding: '3px 10px',
      borderRadius: '999px', background: m.bg, color: m.color,
      border: `1px solid ${m.border}`, letterSpacing: '0.03em',
    }}>
      <span style={{ width: '5px', height: '5px', borderRadius: '50%', background: m.color, flexShrink: 0 }} />
      {m.label}
    </span>
  );
}

export function GLabel({ children }) {
  return <p style={{ fontSize: '12px', fontWeight: 600, color: '#374151', marginBottom: '6px', letterSpacing: '-0.005em' }}>{children}</p>;
}

export function GSection({ label, children }) {
  return (
    <div>
      <p style={{ fontSize: '10px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: '#9CA3AF', marginBottom: '10px' }}>{label}</p>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>{children}</div>
    </div>
  );
}

export function GField({ label, hint, children }) {
  return (
    <div>
      <GLabel>{label}</GLabel>
      {children}
      {hint && <p style={{ fontSize: '11px', color: '#9CA3AF', marginTop: '4px' }}>{hint}</p>}
    </div>
  );
}

export function timeAgo(dateStr) {
  if (!dateStr) return '—';
  const diff = Math.floor((Date.now() - new Date(dateStr)) / 1000);
  if (diff < 60)    return 'just now';
  if (diff < 3600)  return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return new Date(dateStr).toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
}
